import { render, staticRenderFns } from "./ticketPositionComponent.vue?vue&type=template&id=3f64b8d9"
import script from "./ticketPositionComponent.vue?vue&type=script&lang=js"
export * from "./ticketPositionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports